export { default } from './LazyPrivacyNoticeCo';
